<template>
  <section class="montebitProducts-section" id="productos">
    <div class="montebitProducts__information-container">
      <h5>{{ montebitProductsTexts.headerSection }}</h5>
      <h2>{{  montebitProductsTexts.title }}</h2>
      <h4>{{  montebitProductsTexts.subtitle }}</h4>
      <div class="montebitProducts__images-container">
        <img style="cursor: pointer;" :src="require('../../../assets/Frame 3606.png')" @click="websiteDirector('https://rayyo.mx/')"/>
        <img :src="require('../../../assets/Vector.png')"/>
        <img style="cursor: pointer;" :src="require('../../../assets/cryptobox-logo.png')" @click="websiteDirector('https://cryptobox.mx/')"/>
      </div>
    </div>
    <img src="../../../assets/montebit-limites.png"/>
  </section>
</template>
<script>
import {IntersectionObserverMixin} from "@/mixins/IntersectionObserverMixin"
import CardFactors from "@/components/atoms/CardFactors.vue";
import newTexts from "@/data/newTexts"

export default {
  name: "MontebitProducts",
  components: {
    CardFactors,
  },
  mixins: [IntersectionObserverMixin("productos")],
  data(){
    return{
      montebitProductsTexts: newTexts.montebitProductsSection

    }
  },
  methods:{
    websiteDirector(url) {
      window.open(url, "_blank");
    }
  },
};
</script>
